import { Space, Switch } from 'antd';
import { FC } from 'react';
import { ESwitchEnum } from '@/pages/backend/cardCampSettings/nodeSettings/switchEnum';

const NodeSwitch: FC<{
  tips?: string;
  value?: boolean;
  onChange?: (checked: ESwitchEnum) => void;
}> = ({ value, onChange, tips }) => {
  return (
    <Space>
      <Switch
        value={value}
        onChange={(checked) => {
          onChange?.(checked ? ESwitchEnum.open : ESwitchEnum.close);
        }}
      />
      {tips && <span className="text-c0c0c0">{tips}</span>}
    </Space>
  );
};
export default NodeSwitch;
